import { Modal } from "@maysoft/common-component-react"
import { useEffect, useState } from "react"
import FirebaseConfigForm from "../container/firebaseConfig"
import Strings from "constants/strings"
import { SettingProps } from "./simpleConfigModal"
import BasicInfoSection from "../container/baseInfo"


const FirebaseConfigPopup = ({
    serviceName,
    tenantName,
    visibled,
    value,
    onClose,
    onSubmit
}: SettingProps) => {

    const [config, setConfig] = useState<any>({})

    useEffect(() => {
        try {
            setConfig(JSON.parse(value))
        } catch {
            setConfig({})
        }
    }, [value])

    return (
        <Modal
            visible={visibled}
            maxWidth="lg"
            fullWidth
            title="Firebase Configuration"
            buttonAction={Strings.Common.SAVE}
            hasActionButton
            onClose={onClose}
            onAction={() =>
                onSubmit(JSON.stringify(config))
            }
        >
            <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />
            
            <FirebaseConfigForm
                value={config}
                onChange={setConfig}
            />
        </Modal>
    )
}

export default FirebaseConfigPopup